import { fromPairs } from 'ramda';

const encodePlus = encodeURIComponent('+');

export default (params: string) => {
  const encodeParams = params.replace(/\+/g, encodePlus);
  return fromPairs([...new URLSearchParams(encodeParams)]);
};
